// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_header__aT8IF {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Header_header__aT8IF .Header_userInfo__WNz2P {
  display: flex;
  align-items: center;
  gap: 5rem;
}
.Header_header__aT8IF .Header_userInfo__WNz2P > div, .Header_header__aT8IF .Header_userInfo__WNz2P > button {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}
.Header_header__aT8IF .Header_userInfo__WNz2P > div > svg, .Header_header__aT8IF .Header_userInfo__WNz2P > button > svg {
  width: 2.4rem;
  height: 2.4rem;
}
.Header_header__aT8IF .Header_userInfo__WNz2P > button {
  color: var(--blue);
}

@media (max-width: 800px) {
  .Header_header__aT8IF .Header_btnMobile__e-N1G {
    padding: 1rem;
  }
  .Header_header__aT8IF .Header_btnMobile__e-N1G > div:nth-of-type(1) {
    display: flex;
    padding: 0.8rem;
    border-radius: 100%;
    border: 1px solid #edf1ce;
    box-shadow: 0px 0px 8.4px 0px #00a4f4;
  }
  .Header_header__aT8IF .Header_btnMobile__e-N1G > div:nth-of-type(1) > svg {
    width: 2.2rem;
    height: 2.2rem;
  }
  .Header_header__aT8IF .Header_btnMobile__e-N1G > div:nth-of-type(1) > svg > g > path {
    fill: var(--fill-blue-light);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/Header/Header.module.scss"],"names":[],"mappings":"AAAA;EAEC,aAAA;EACA,8BAAA;EACA,mBAAA;AAAD;AAEC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAAF;AAEE;EAEC,aAAA;EACA,mBAAA;EACA,WAAA;AADH;AAGG;EACC,aAAA;EACA,cAAA;AADJ;AAIE;EACC,kBAAA;AAFH;;AAOA;EAEE;IACC,aAAA;EALD;EAOC;IACC,aAAA;IACA,eAAA;IACA,mBAAA;IACA,yBAAA;IACA,qCAAA;EALF;EAME;IACC,aAAA;IACA,cAAA;EAJH;EAMG;IACC,4BAAA;EAJJ;AACF","sourcesContent":[".header {\n\t// padding: 7rem 0 11rem;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\n\t.userInfo {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 5rem;\n\n\t\t& > div,\n\t\t& > button {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tgap: 0.8rem;\n\n\t\t\t& > svg {\n\t\t\t\twidth: 2.4rem;\n\t\t\t\theight: 2.4rem;\n\t\t\t}\n\t\t}\n\t\t& > button {\n\t\t\tcolor: var(--blue);\n\t\t}\n\t}\n}\n\n@media (max-width: 800px) {\n\t.header {\n\t\t.btnMobile {\n\t\t\tpadding: 1rem;\n\n\t\t\t& > div:nth-of-type(1) {\n\t\t\t\tdisplay: flex;\n\t\t\t\tpadding: 0.8rem;\n\t\t\t\tborder-radius: 100%;\n\t\t\t\tborder: 1px solid #edf1ce;\n\t\t\t\tbox-shadow: 0px 0px 8.4px 0px #00a4f4;\n\t\t\t\t& > svg {\n\t\t\t\t\twidth: 2.2rem;\n\t\t\t\t\theight: 2.2rem;\n\n\t\t\t\t\t& > g > path {\n\t\t\t\t\t\tfill: var(--fill-blue-light);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header_header__aT8IF`,
	"userInfo": `Header_userInfo__WNz2P`,
	"btnMobile": `Header_btnMobile__e-N1G`
};
export default ___CSS_LOADER_EXPORT___;
